import { REGIONS, regionOf, CITY_CODES } from "./cities";
import { ALBERTA_CITIES, ALBERTA_SERVICES } from "./nav";

const NAME_FIX = { "st-albert": "St. Albert", "st-paul": "St. Paul", "fort-mcmurray": "Fort McMurray", "lac-la-biche": "Lac La Biche", "fort-macleod": "Fort Macleod" };
export const cityName = (slug) => NAME_FIX[slug] || slug.split("-").map((w) => w[0].toUpperCase() + w.slice(1)).join(" ");

export const REGION_LABELS = { edmonton: "Edmonton & area", calgary: "Calgary & area", "red-deer": "Red Deer & Central Alberta", lethbridge: "Lethbridge & Southern Alberta", "medicine-hat": "Medicine Hat & area", "grande-prairie": "Grande Prairie & Northern Alberta", "fort-mcmurray": "Fort McMurray & the Northeast" };
export const ALL_CITY_SLUGS = [...new Set([...ALBERTA_CITIES.map(([, h]) => h.replace(/\//g, "")), ...Object.values(REGIONS).flat()])];
const ANCHOR_CITIES = Object.keys(REGIONS);
const FULL_PATHS = new Set(["/", "/locations/", "/rates", "/rates-preview"]);

// Full directory on home / hubs / /locations/; a short "nearby" strip everywhere else (sitewide footer links are boilerplate to Google).
export const isFullDirectory = (pathname) => FULL_PATHS.has(pathname) || (pathname.split("/").filter(Boolean).length === 1 && ALL_CITY_SLUGS.includes(pathname.replace(/\//g, "")));

export function compactDirectory(pathname) {
  const first = pathname.split("/").filter(Boolean)[0];
  const region = ALL_CITY_SLUGS.includes(first) ? regionOf(first) : null;
  const slugs = region ? [region, ...REGIONS[region].filter((s) => s !== region)].slice(0, 6) : ANCHOR_CITIES;
  const label = region ? `Mortgage help near ${cityName(first)}` : "Mortgage help across Alberta";
  const places = [...slugs.map((s) => [`${cityName(s)} mortgage broker`, `/${s}/`]), ["All Alberta communities →", "/locations/"]];
  if (region) {
    const C = cityName(first);
    return {
      word: `"hello, ${C}."`, eyebrow: `Explore ${C} mortgages`, heading: `Your ${C} mortgage questions live here.`,
      text: `Find mortgage help across the ${C} area, then explore the local buying, renewal, refinancing and specialty mortgage pages that match your plans.`,
      kicker: CITY_CODES[first] || "AB", kickerLabel: label, places,
      serviceLabel: `${C} mortgage services`,
      services: [[`${C} mortgage rates`, `/${first}/mortgage-rates/`], ...ALBERTA_SERVICES.slice(0, 5).map(([l, h]) => [`${C} ${l.charAt(0).toLowerCase()}${l.slice(1)}`, h.replace("/mortgages/", `/${first}/`)])],
    };
  }
  return {
    word: '"hello, Alberta."', eyebrow: "Explore Hello Mortgage", heading: "Your mortgage questions live here.",
    text: "Whether you’re buying, renewing, refinancing or simply trying to make the numbers behave, start with the service—or the Alberta community—that feels most like home.",
    kicker: "AB", kickerLabel: label, places,
    serviceLabel: "Find your mortgage strategy", services: ALBERTA_SERVICES.slice(0, 6),
  };
}
